export const formatNumber = (value, options)=>{
    const formatter = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: options?.maximumFractionDigits,
        minimumFractionDigits: options?.minimumFractionDigits
    });
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    return formatter.format(isNaN(numericValue) ? 0 : numericValue);
};

//# sourceMappingURL=formatNumber.js.map